export default {
  lastJobInterval: null,

  checkLastInternalJobStatus(id) {
    $.ajax({
      url: 'api/last_internal_job_status/' + id,
      success: (response) => {
        if (response && response.estado !== 'PROCESSING') {
          this.lastJobInterval = null;
          window.location.reload();
        }
      }
    })
  },

  initLastInternalJobInterval() {
    const $processingContainer = $('.js-processing-internal-job');
    if ($processingContainer.length > 0) {
      this.lastJobInterval = setInterval(() => {
        const id = $processingContainer.data('id');
        this.checkLastInternalJobStatus(id);
      }, 3500);
    }
  },

  check() {
    this.initLastInternalJobInterval();
  }
}
